import { createAsyncThunk } from '@reduxjs/toolkit';
import { ax } from 'services/apiService';


export const saveResource = createAsyncThunk('save-resource', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourceupload`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const updateResource = createAsyncThunk('update-resource', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourceupdate`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const deleteResource = createAsyncThunk('delete-resource', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourcedelete`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const shareResource = createAsyncThunk('share-resource', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourceshare`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const accessResource = createAsyncThunk('access-resource', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourceaccess`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const resourceDetails = createAsyncThunk('resource-detail', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourcedetail`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const resourceDetailsPagenation = createAsyncThunk('resource-page-detail', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourcedetail_info`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const resourceupdate = createAsyncThunk('resource-re-upload', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/resourceupdate`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const resourceComment = createAsyncThunk('resource-comment', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/save_resource_comment`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const resourceLike = createAsyncThunk('resource-like', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`docrepo/save_resource_like`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const disableResourceSharing = createAsyncThunk('disable-resource-sharing', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`docrepo/resourcesharedisable/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response);
        }
    }
});
export const getResourceList = createAsyncThunk('get-resource-list', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`docrepo/resourcelist/0`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response);
        }
    }
});

export const downloadResource = createAsyncThunk('download-resource', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`docrepo/resource_download/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response);
        }
    }
});